import { useEffect } from "react";
import { setTitle } from "../helpers/jsHelper";

// TODO: use react-helmet instead if time allows
export const usePageTitle = (title, deps = []) => {
  useEffect(() => {
    setTitle(title);
  }, [title, ...deps]);
}

export const usePageMetaTags = ({ title, description, thumbnail } = {}) => {
  const setMetaTag = (name, content, property = false) => {
    // if (!content) return;
    let selector = property ? `meta[property='${name}']` : `meta[name='${name}']`; // Select the appropriate meta tag
    let tag = document.querySelector(selector);

    if (!tag) {
      // If the tag does not exist, create a new one
      tag = document.createElement('meta');
      tag.setAttribute(property ? 'property' : 'name', name);
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', content);
  };

  usePageTitle(title);

  useEffect(() => {
    setMetaTag('description', description);
    setMetaTag('og:image', thumbnail, true);

    // Cleanup: Reset content instead of removing the tag
    return () => {
      setMetaTag('description', '');
      setMetaTag('og:image', '', true);
    };
  }, [description, thumbnail]);
};